"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneSeparatorFromString = exports.normalizeMillisecondsField = exports.normalizeMillisecondsFieldInString = exports.jsDate = exports.anyTrue = exports.allTrue = exports.typeIsArray = exports.isNull = exports.numerical_sort = exports.removeNulls = void 0;
function removeNulls(things) {
    return things.filter(function (x) { return x != null; });
}
exports.removeNulls = removeNulls;
function numerical_sort(things, direction) {
    return things.sort(function (a, b) {
        if (direction == null || direction === 'asc' || direction === 'ascending') {
            return a - b;
        }
        else {
            return b - a;
        }
    });
}
exports.numerical_sort = numerical_sort;
function isNull(value) {
    return value === null;
}
exports.isNull = isNull;
exports.typeIsArray = Array.isArray || (function (value) { return ({}.toString.call(value) === '[object Array]'); });
function allTrue(things) {
    if ((0, exports.typeIsArray)(things)) {
        return things.every(function (x) { return x; });
    }
    else {
        return things;
    }
}
exports.allTrue = allTrue;
function anyTrue(things) {
    if ((0, exports.typeIsArray)(things)) {
        return things.some(function (x) { return x; });
    }
    else {
        return things;
    }
}
exports.anyTrue = anyTrue;
//The export below is to make it easier if js Date is overwritten with CQL Date
exports.jsDate = Date;
function normalizeMillisecondsFieldInString(string, msString) {
    // TODO: verify we are only removing numeral digits
    var timezoneField;
    msString = normalizeMillisecondsField(msString);
    var _a = string.split('.'), beforeMs = _a[0], msAndAfter = _a[1];
    var timezoneSeparator = getTimezoneSeparatorFromString(msAndAfter);
    if (timezoneSeparator) {
        timezoneField = msAndAfter != null ? msAndAfter.split(timezoneSeparator)[1] : undefined;
    }
    if (timezoneField == null) {
        timezoneField = '';
    }
    return (string = beforeMs + '.' + msString + timezoneSeparator + timezoneField);
}
exports.normalizeMillisecondsFieldInString = normalizeMillisecondsFieldInString;
function normalizeMillisecondsField(msString) {
    // fix up milliseconds by padding zeros and/or truncating (5 --> 500, 50 --> 500, 54321 --> 543, etc.)
    return (msString = (msString + '00').substring(0, 3));
}
exports.normalizeMillisecondsField = normalizeMillisecondsField;
function getTimezoneSeparatorFromString(string) {
    if (string != null) {
        var matches = string.match(/-/);
        if (matches && matches.length === 1) {
            return '-';
        }
        matches = string.match(/\+/);
        if (matches && matches.length === 1) {
            return '+';
        }
    }
    return '';
}
exports.getTimezoneSeparatorFromString = getTimezoneSeparatorFromString;
//# sourceMappingURL=util.js.map